import loadScripts from '../../utils/loadScript';
import { LOGGER_NAME, WHATFIX_URL } from './constants';
import logger from '../../config/app.logger';
//@ts-ignore
import { isValidUrl } from '@mindtickle/utils';
import { getExtendedLogger } from '../Logger';
import { TWhatfixVariables, whatfixConfig } from './types';
import { isAdminSite } from '../../utils';

const log = getExtendedLogger(LOGGER_NAME, logger);

declare global {
  interface Window {
    MTWhatfixVariables: TWhatfixVariables;
  }
}

export function loadWhatfix(whatfixConfig: whatfixConfig) {
  const whatfixLearnerUrl = isValidUrl(whatfixConfig?.learnerUrl)
    ? whatfixConfig?.learnerUrl
    : WHATFIX_URL.LEARNER;
  const whatfixAdminUrl = isValidUrl(whatfixConfig?.adminUrl)
    ? whatfixConfig?.adminUrl
    : WHATFIX_URL.ADMIN;
  const whatfixUrl = isAdminSite() ? whatfixAdminUrl : whatfixLearnerUrl;

  if (!whatfixUrl) {
    log('Whatfix URL is not provided. Skipping loading');
    throw new Error('Whatfix URL is not provided');
  }
  log('loading Whatfix');

  // Returns a promise when script is loaded
  return loadScripts({ url: whatfixUrl, defer: true });
}

export function setWhatfixVariables(variables: TWhatfixVariables) {
  if (window.MTWhatfixVariables) {
    window.MTWhatfixVariables = { ...window.MTWhatfixVariables, ...variables };
  } else {
    window.MTWhatfixVariables = variables;
  }
  log(`variables set successfully`);
}
